import React, {useEffect, useState} from 'react';
import close from "../../../images/close.svg";
import {Formik} from "formik";
import * as Yup from "yup";
import CommonInput from "../CommonInput/CommonInput";
import {userApi} from "../../../redux/user/user-api";
import {connect} from "react-redux";
import {authApi} from "../../../redux/auth/auth-api";
import {resetPassword} from "../../../redux/user/user-thunks";
import {useTranslation} from "react-i18next";

const ChangePassword = ({closeModal, isDark, user, resetPassword, token, isRecovery}) => {
  const [isPasswordsEqual, setIsPasswordsEqual] = useState(true)
  const [isUnCorrectPassword, setIsUnCorrectPassword] = useState(false)
  const {t} = useTranslation()
  return (
    <div style={{width: 485}} className={`modal pr-40 ${isDark && 'modal__dark'}`}>
      <h5 className="modal__mainTitle mr-30">{t('changingPassword')}</h5>
      <button onClick={closeModal} className="modal__close">
        <img src={close} alt=""/>
      </button>
      <Formik
        initialValues={{
          password: '',
          newPassword: '',
          newPasswordRepeat: ''
        }}
        validationSchema={Yup.object({
          password: Yup.string(),
          newPassword: Yup.string()
            .min(8, t('passwordChars'))
            .required(t('requiredField')),
          newPasswordRepeat: Yup.string()
            .min(8, t('passwordChars'))
            .required(t('requiredField')),
        })}
        onSubmit={async (values, {resetForm}) => {
          setIsUnCorrectPassword(false)
          setIsPasswordsEqual(true)
          if(values.newPassword !== values.newPasswordRepeat) {
            setIsPasswordsEqual(false)
          } else {
            try {
              if(!isRecovery) await authApi.login(user.email, values.password)
              resetPassword(token, values.newPassword)
              closeModal()
            } catch (e) {
              setIsUnCorrectPassword(true)
            }
          }
        }}
      >
        {({values, handleChange, handleSubmit, errors, ...formikProps}) => {
          if(values.newPassword === values.newPasswordRepeat) {
            setIsPasswordsEqual(true)
          }
          return <form onSubmit={handleSubmit} className={'modal__section mt-0 pb-0'}>
            {!isRecovery && <CommonInput type={'password'} caption={`${t('oldPassword')}:`}
                         value={values.password} setValue={handleChange} id={'password'}
                         error={formikProps.submitCount > 0 && (errors.password || (isUnCorrectPassword && t('incorrectOldPassword')))}/>}
            <CommonInput type={'password'} caption={`${t('newPassword')} :`}
                         value={values.newPassword} setValue={handleChange} id={'newPassword'}
                         error={formikProps.submitCount > 0 && (errors.newPassword || !isPasswordsEqual)}/>
            <CommonInput type={'password'} caption={`${t('confirmPass')}:`}
                         value={values.newPasswordRepeat} setValue={handleChange} id={'newPasswordRepeat'}
                         error={formikProps.submitCount > 0 && (errors.newPasswordRepeat || (!isPasswordsEqual && t('passwordMismatch')))}/>
            <div className="modal__actions mt-16">
              <button type={'submit'} className="submit-button">
                {t('accept')}
              </button>
              <button onClick={closeModal} className={`commonBtn ${isDark && 'commonBtn__dark'}`}>
                <span className={'commonBtn__label'}>{t('cancel')}</span>
              </button>
            </div>
          </form>
        }}
      </Formik>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.userReducer.user
})

export default connect(mapStateToProps, {resetPassword})(ChangePassword);
